import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className,
  icon: Icon,
  iconPosition = 'left',
  ...props
}) => {
  const baseClasses = "inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-primary-600 hover:bg-primary-700 text-white focus:ring-primary-500",
    secondary: "bg-gray-200 hover:bg-gray-300 text-gray-900 focus:ring-gray-500",
    success: "bg-success-600 hover:bg-success-700 text-white focus:ring-success-500",
    danger: "bg-danger-600 hover:bg-danger-700 text-white focus:ring-danger-500",
    warning: "bg-warning-600 hover:bg-warning-700 text-white focus:ring-warning-500",
    softBlue: "border border-sky-200 bg-sky-100 hover:bg-sky-200 text-sky-800 focus:ring-sky-400",
    softGreen: "border border-emerald-200 bg-emerald-100 hover:bg-emerald-200 text-emerald-800 focus:ring-emerald-400",
    attendancePrimary: "border border-green-200 bg-green-50 hover:bg-green-100 text-green-800 focus:ring-green-500",
    attendanceSecondary: "border border-blue-200 bg-blue-50 hover:bg-blue-100 text-blue-800 focus:ring-blue-500",
    attendanceNeutral: "border border-slate-300 bg-slate-50 hover:bg-slate-100 text-slate-700 focus:ring-slate-400",
    outline: "border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 focus:ring-primary-500",
    ghost: "text-gray-700 hover:bg-gray-100 focus:ring-gray-500"
  };

  const sizes = {
    sm: "px-2.5 py-1.5 text-xs",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-sm",
    xl: "px-6 py-2.5 text-base"
  };

  const isDisabled = disabled || loading;

  return (
    <motion.button
      className={clsx(
        baseClasses,
        variants[variant],
        sizes[size],
        isDisabled && "opacity-50 cursor-not-allowed",
        className
      )}
      disabled={isDisabled}
      whileHover={!isDisabled ? { scale: 1.02 } : {}}
      whileTap={!isDisabled ? { scale: 0.98 } : {}}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      
      {Icon && iconPosition === 'left' && !loading && (
        <Icon className="w-4 h-4 mr-2" />
      )}
      
      {children}
      
      {Icon && iconPosition === 'right' && !loading && (
        <Icon className="w-4 h-4 ml-2" />
      )}
    </motion.button>
  );
};

export default Button;
